import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { GetRunLogFiltersResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  children?: (data: GetRunLogFiltersResponse) => ReactElement
  onSuccess?: (data: GetRunLogFiltersResponse) => void
}

const GetAiRunLogFiltersRequest = ({
  id,
  children,
  onSuccess
}: Props) => {
  const url = `${AI_API_SERVICE}/runlogs/${id}/filters`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetAiRunLogFiltersRequest
